import React from "react";
import {
  withStyles,
  ListItem,
  Radio,
  FormControlLabel,
  RadioGroup,
  Menu,
  withTheme
} from '@material-ui/core';
import {
  RadioButtonUnchecked as RadioButtonUncheckedIcon,
  RadioButtonChecked as RadioButtonCheckedIcon
} from '@material-ui/icons';
import { compose } from "recompose";

const styles = (theme) => ({
  radioLabel: {
    height: "12px",
    fontSize: "18px",
  },
  label: {
    color: theme.TextColor,
    fontWeight: 600,
    fontSize: theme.textFontSize,
  },
  radioRoot: {
    width: "10px",
    color: theme.headColor,
    height: "10px",
    fontSize: "18px",
  },
  noOptions: {
    padding: "18px",
    color: theme.headColor,
    fontSize: theme.textFontSize,
  },
  terminalClicked: {
    padding: "10px 17px",
    backgroundColor: theme.ModalBGColor,
  },
  terminalMenu: {
    background: theme.ModalBGColor,
    borderRadius: "0px 0px 4px 4px",
    marginTop: "10px",
    marginLeft: "12px",
    maxHeight: 320,
  },
});

const SelectPickupTerminal = ({
  classes,
  terminalAnchor,
  closeTerminalMenu,
  terminalOptions,
  activeTerminal,
  handleTerminalChange,
  theme,
}) => {
  const changeTerminal = (event) => {
    handleTerminalChange(event.target.value);
  };
  return (
    <Menu
      disablePortal={false}
      getContentAnchorEl={null}
      disableAutoFocusItem={true}
      anchorReference="anchorPosition"
      anchorPosition={{ top: 42, left: 16 }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={true}
      container={terminalAnchor}
      onClose={closeTerminalMenu}
      MenuListProps={{ disablePadding: true }}
      classes={{
        paper: classes.terminalMenu,
      }}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
        {terminalOptions.length ? (
          terminalOptions.map((terminalCode) => (
            <ListItem
              key={terminalCode}
              classes={{ root: classes.terminalClicked}}
              disableGutters
            >
              <RadioGroup
                aria-label="Terminal"
                name="terminal"
                value={activeTerminal}
                onChange={(event) => changeTerminal(event)}
              >
                <FormControlLabel
                  classes={{
                    root: classes.radioLabel,
                    label: classes.label,
                  }}
                  value={terminalCode}
                  control={
                    <Radio
                      color={theme.headColor}
                      classes={{ root: classes.radioRoot }}
                      icon={<RadioButtonUncheckedIcon fontSize="small" />}
                      checkedIcon={<RadioButtonCheckedIcon fontSize="small" />}
                    />
                  }
                  label={terminalCode}
                />
              </RadioGroup>
            </ListItem>
          ))
        ) : (
          <div className={classes.noOptions}>No Data Available</div>
        )}
    </Menu>
  );
};

export default compose(withStyles(styles), withTheme())(SelectPickupTerminal);
